import { module } from 'angular';

import { AttachmentDirective, default as attachmentDirectiveName } from './attachment.directive';

export default module('contact.commons.toolbox.attachment', []).directive(attachmentDirectiveName, AttachmentDirective).name;
